<template>
  <div class="main-container">
    <TheSideBar>
      <template #default>
        <router-link :to="{name: 'tasksList', params: {status: '$active'}}">
          <i class="fas fa-list"></i>
          Aktivní úkoly
        </router-link>
        <router-link v-for="s in activeStates"
                     :key="s.id"
                     :to="{name: 'tasksList', params: {status: s.id}}"
                     class="l1"
        >
          <i class="fas"
             :class="[s.icon]"
             :style="{'color': s.color}"
          ></i>
          {{ s.label }}
        </router-link>

        <router-link :to="{name: 'tasksList', params: {status: '$inactive'}}">
          <i class="fas fa-list"></i>
          Neaktivní úkoly
        </router-link>
        <router-link v-for="s in inactiveStates"
                     :key="s.id"
                     :to="{name: 'tasksList', params: {status: s.id}}"
                     class="l1"
        >
          <i class="fas"
             :class="[s.icon]"
             :style="{'color': s.color}"
          ></i>
          {{ s.label }}
        </router-link>
        <router-link :to="{name: 'tasksList', params: {status: '$deleted'}}"
                     class="l1"
        >
          <i class="fas fa-trash"
             style="color: OrangeRed"
          ></i>
          Koš
        </router-link>
        <hr class="separator" />
        <router-link v-if="$store.getters.currentUserHasAction('ADD_TASK')"
                     :to="{name: 'tasksNew'}"
        >
          <i class="fas fa-plus-circle"></i>
          {{ $t('task.new') }}
        </router-link>
        <router-link v-if="$store.getters.currentUserHasAction('MANAGE_TASK_TYPES')"
                     :to="{name: 'taskTypesList'}"
        >
          <i class="fas fa-list"></i>
          {{ $t('task.type.list') }}
        </router-link>
        <router-link v-if="$store.getters.currentUserHasAction('MANAGE_TASK_TYPES')"
                     :to="{name: 'taskTypeNew'}"
        >
          <i class="fas fa-plus-circle"></i>
          {{ $t('task.type.new') }}
        </router-link>
      </template>
    </TheSideBar>
    <DataReady id="content">
      <router-view :key="$route.path"></router-view>
    </DataReady>
  </div>
</template>

<script>
import TheSideBar from 'CORE/components/side-bar/the-side-bar'
import DataReady from 'CORE/components/utilities/data-ready'
import { active, inactive } from 'ENUMS/entity-states-groups'

export default {
    name: 'TasksView',
    components: {
        TheSideBar,
        DataReady,
    },
    computed: {
        activeStates() {
            return active
        },
        inactiveStates() {
            return inactive
        },
    },
}
</script>
